import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./app/App";
import store from "./store";
import ContextProvider from "./context/ContextProvider";

import "rsuite/dist/rsuite-no-reset.min.css";
import "./index.scss";

// Import Firebase first to ensure it's initialized before other services
import "src/services/firebase";
import "src/services/i18nLocalization";
import "src/services/googleTagManager";

// Patch for MutationObserver errors from browser extensions
const originalMutationObserver = window.MutationObserver;
try {
  window.MutationObserver = class PatchedMutationObserver extends (
    originalMutationObserver
  ) {
    constructor(callback: MutationCallback) {
      super((mutations: MutationRecord[], observer: MutationObserver) => {
        try {
          callback(mutations, observer);
        } catch (error) {
          console.warn("MutationObserver error intercepted:", error);
        }
      });
    }

    observe(target: Node, options?: MutationObserverInit): void {
      if (!target) {
        console.warn("Attempted to observe null target");
        return;
      }
      try {
        super.observe(target, options);
      } catch (error) {
        console.warn("MutationObserver observe error intercepted:", error);
      }
    }
  };
} catch (error) {
  console.warn("Unable to patch MutationObserver:", error);
}

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <ContextProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ContextProvider>
  </Provider>,
);
